module.exports = __webpack_public_path__ + "static/media/apple-app-store-badge.a9379aeb.png";